export const network = 1;
export const switchNetworkId = "0x1";
export const infuraID = "b8091fc239d74e67b92711d292ae152a";
export const version = "1";
export const pendingProposal = "";
export const closedProposal = "";
export const apiBaseUrl =
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === "development"
    ? "http://localhost:1000/"
    : "https://api.cultdao.io/");
